import type { TowerType, EnemyType } from '../core/types';

/**
 * Display order for the debug/review screen (DemoScene STATS tab). Kept in a
 * pure, Phaser-free module so a unit test can assert it covers every tower and
 * enemy — guarding against adding a unit but forgetting to list it in debug mode.
 */
export const TOWER_ORDER: TowerType[] = [
  'patty',
  'pickle',
  'cheese',
  'bacon',
  'sauce',
  'blade',
  'bomb',
  'wise',
  'wizard',
  'sniper',
  'darkhambi',
  'ninja',
  'sensei',
  'boxer',
  'gunner',
  'firemage',
  'aquasorcerer',
  'shrekbook',
  'phantom',
  'lightning',
  'spear',
  'bow',
  'capy',
  'generalcapy',
  'galacticcapy',
  'hog',
  'magecapy',
  'minigunner',
  'kingcapy',
  'kinghambi',
  'dagger',
  'leafstorm',
  'samurai',
  'masher',
  'grease',
  'ultrahammy',
  'horror',
  'demonic',
  'hamreaper',
  'healer',
  'banker',
  'angelic',
  'goldenshroom',
];

export const ENEMY_ORDER: EnemyType[] = [
  'grunt',
  'dino',
  'fry',
  'hotdog',
  'boss',
  'frost',
  'icedino',
  'driller',
  'nullnugget',
  'ultranugget',
  'jockey',
  'watcher',
  'nuggetguard',
  'kingnuggetron',
  'carrotcrusher',
  'carrotninja',
  'brocco',
  'potatoslicer',
  'drycarrot',
  'minibell',
  'emperorpepro',
  'caulifire',
  'esparagusmage',
  'ocraa',
  'bamboocrew',
  'peproherald',
  'kingember',
  'shrekbruit',
  'cosmiccorroder',
  'nuisancenugget',
  'barwaiter',
  'burntfry',
  'microwavednugget',
  'combo199',
  'chiply',
  'microwave',
  'chiplysdad',
  'nacho',
  'seasonezchippington',
  'lifeguard',
  'moonnacho',
  'spicednacho',
  'lasernacho',
  'princenacho',
  'princenacho2',
  'ghost',
  'thedead',
  'darkghost',
  'darknacho',
  'jackoghost',
  'blueghost',
  'reaper',
  'winger',
  'twilight',
  'nightfly',
  'halolight',
  'halolight2',
  'halolight3',
  'lordturtleshell',
  'redshroom',
  'poisonshroom',
  'skullshroom',
  'purplefungi',
  'themushy',
  'glowshroom',
  'blizzardfungi',
  'zombieshroom',
  'hynofungi',
  'kingshroometron',
];
